'use client'
import * as viemChains from 'viem/chains';

// eslint-disable-next-line import/no-namespace
const chainsMap = Object.values(viemChains).reduce((acc, chain) => (Object.assign(Object.assign({}, acc), { [chain.id]: chain })), {});

export { chainsMap };
